import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';

import ApiService from 'cio/services/api';
import CollectionDataController from 'cio/pods/collections/collection/data/controller';
import { CollectionParams } from 'cio/pods/collections/collection/route';

export default class CollectionsRoute extends Route {
  @service api!: ApiService;

  queryParams = {
    viewAs: {
      replace: true,
    },
    filters: {
      refreshModel: true,
      replace: true,
    },
    sort: {
      refreshModel: true,
      replace: true,
    },
    asc: {
      refreshModel: true,
      replace: true,
    },
    page: {
      refreshModel: true,
    },
  };

  model({ page, filters, asc, sort }: { page: number; filters: string; asc: boolean; sort: string }) {
    let collectionParams = this.paramsFor('collections.collection');

    return this.api.request('collection_items', {
      data: {
        page,
        asc,
        order_by: sort,
        conditions: filters,
        collection_id: (collectionParams as CollectionParams).collection_id,
      },
    });
  }

  setupController(controller: CollectionDataController, model: Record<string, any>[], transition: Transition) {
    super.setupController(controller, model, transition);
    controller.setVisibleColumns();
  }

  resetController(controller: CollectionDataController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }
}
